export const PAGE_SIZE = 20;

export const COLUMN_WIDTH = 250;

// Column configuration
export const COLUMN_CONFIG = {
  cropZone: {
    title: 'Crop Zones',
    dataIndex: 'cropZoneName',
    key: 'cropZoneName',
    width: COLUMN_WIDTH
  },
  crop: {
    title: 'Crop',
    dataIndex: 'cropName',
    key: 'cropName',
    width: COLUMN_WIDTH
  },
  farm: {
    title: 'Farm',
    dataIndex: 'farmName',
    key: 'farmName',
    width: COLUMN_WIDTH
  },
  appliedArea: {
    title: 'Appl.\u00a0Acreage',
    dataIndex: 'appliedArea',
    key: 'appliedArea',
    width: COLUMN_WIDTH
  }
};

// Field Icon configuration
export const FIELD_ICON_CONFIG = {
  border: '#868CA2',
  color: '#DFE2E7',
  width: 32,
  height: 32
};

// Crop Icon configuration
export const CROP_ICON_SIZE = 18;

// Text colors
export const COLORS = {
  fieldText: '#696F88',
  percentageText: '#696F88'
};

// Font sizes
export const FONT_SIZES = {
  fieldName: '14px',
  percentage: '12px'
};
